"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconsSink = void 0;
const Icons = require("client/components/icons");
const react_1 = require("react");
const React = require("react");
require("./icons.less");
class IconsSink extends react_1.Component {
    render() {
        const allIcons = Object.keys(Icons).map((key) => {
            const icon = React.createElement(Icons[key]);
            return (React.createElement("div", { key: key, className: "icon" },
                icon,
                React.createElement("h4", null, key.replace("Icon", ""))));
        });
        return (React.createElement("div", { className: "icons" },
            React.createElement("h2", null, "Icons"),
            React.createElement("div", { className: "icon-row" }, allIcons)));
    }
}
exports.IconsSink = IconsSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/icons/icons.tsx
// module id = 3635
// module chunks = 0